import { Notification, variants } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { price as priceUtil } from '@eti/utils';
import { RichTextContent } from '@etg/wings';

interface PriceChangeNotificationProps {
  diff: number;
}
const PriceChangeNotification = ({ diff }: PriceChangeNotificationProps) => {
  const isPriceIncrease = (diff ?? 0) >= 0;

  const { t } = useTranslation();
  return (
    <Notification
      dataTestId={
        isPriceIncrease
          ? 'paymentPage-priceChangeNotification-increase'
          : 'paymentPage-priceChangeNotification-decrease'
      }
      variant={variants.WARNING}
    >
      <RichTextContent>
        {t(
          isPriceIncrease
            ? 'Payment.PriceChange.Increase.Notification'
            : 'Payment.PriceChange.Decrease.Notification',
          `<span data-testid="paymentPage-priceChangeNotification-priceDiff">${priceUtil.formatPrice(
            diff,
          )}</span>`,
        )}
      </RichTextContent>
    </Notification>
  );
};

export default PriceChangeNotification;
